
if ($("#image-viewer").length > 0) {
    var jsPortalFileId = '';
    var ivDocIndex = 0;
    var ivDocRotation = 0;
    var ivDocList;
    var ivLoadCallback;
    var ivRotCallback;
    var filedata;
    var ivRequestTypeCd = -1;
    var ivUid = '';

    function SetUpViewer(idList, requesttypecd, uid, loadCallback, rotCallback) {
        ivDocList = idList;
        ivRequestTypeCd = requesttypecd;
        ivUid = uid;
        ivLoadCallback = loadCallback;
        ivRotCallback = rotCallback;
        ivDocIndex = 0;
        if (ivDocList.length > 0) {
            if (ivDocList.length > 1) {
                $('#btn-iv-prev').removeClass('d-none');
                $('#btn-iv-next').removeClass('d-none');
            }
            SetImage(ivDocList[ivDocIndex]);
        }
        rescale();
    }

    var img = $("#image-viewer")

    $("#btn-iv-zoomout").on("click", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        img.viewer("zoom", -0.5);
    });

    $("#btn-iv-zoomin").on("click", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        img.viewer("zoom", 0.5);
    });

    $("#btn-iv-prev").on("click", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        ivDocIndex--;

        if (ivDocIndex < 0) {
            ivDocIndex = ivDocList.length - 1;
        }

        SetImage(ivDocList[ivDocIndex]);
    });

    $("#btn-iv-next").on("click", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        ivDocIndex++;

        if (ivDocIndex >= ivDocList.length) {
            ivDocIndex = 0;
        }


        SetImage(ivDocList[ivDocIndex]);
    });

    $("#btn-iv-rotleft").on("click", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        img.viewer("rotate", -90);

        rot = img.data("viewer").imageData.rotate % 360;
        rot = rot < 0 ? 360 + rot : rot;
        SaveImageRotation(rot);

        //if (ivRotCallback !== undefined) {
        //    ivRotCallback(rot);
        //}
    });

    $("#btn-iv-rotright").on("click", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        img.viewer("rotate", 90);

        rot = img.data("viewer").imageData.rotate % 360;
        rot = rot < 0 ? 360 + rot : rot;
       SaveImageRotation(rot);

        //if (ivRotCallback !== undefined) {
        //    ivRotCallback(rot);
        //}
    });


    function SaveImageRotation(rotataion) {
        var deleteurl = '';

        if (location.href.indexOf('/en/') > 0) {
            deleteurl = location.href.split('/en/')[0] + '/en/FileUpload/UpdateImageRotation/';
        } else {
            deleteurl = location.href.split('/fr/')[0] + '/fr/FileUpload/UpdateImageRotation/';
        }

        $.ajax({
            url: deleteurl + '?portalfileid=' + jsPortalFileId + '&imagerotation=' + rotataion + '&requestTypeCd=' + ivRequestTypeCd + '&uid=' + ivUid,
            method: 'POST',
            contentType: false,
            processData: false,
            success: function (res) {
                return true;
            }
        });
    }

    function SetImage(portalfileId) {
        $(".iv-loading").removeClass("d-none");
        $(".iv-loading").addClass("d-flex");
        $(".iv-img-container").addClass("d-none");
        $(".iv-doc-container").addClass("d-none");
        
        $("#btn-iv-zoomout").addClass("d-none");
        $("#btn-iv-zoomin").addClass("d-none");
        $("#btn-iv-rotleft").addClass("d-none");
        $("#btn-iv-rotright").addClass("d-none");
        $("#btn-iv-openfile").addClass("d-none");
        $("#btn-iv-prev").prop("disabled", true);
        $("#btn-iv-next").prop("disabled", true);
        $("#viewUploadedDocModal").modal();
        var url = '';
        var queryString = '?fileUploadId=' + portalfileId + '&requestTypeCd=' + ivRequestTypeCd + '&uid=' + ivUid;
        if (location.href.indexOf('/en/') > 0) {
            url = location.href.split('/en/')[0] + '/en/FileUpload/GetFileData/' + queryString;
        } else {
            url = location.href.split('/fr/')[0] + '/fr/FileUpload/GetFileData/' + queryString;
        }
        $.ajax({
            url: url,
            method: 'POST',
            contentType: false,
            processData: false,
            success: function (data) {

                if (ivDocIndex > 0) {
                    $("#btn-iv-prev").prop("disabled", false);
                }

                if (ivDocIndex < ivDocList.length - 1) {
                    $("#btn-iv-next").prop("disabled", false);
                }

                if (data !== null && data !== undefined && data.result !== undefined && data.result !== 0) {
                    filedata = data;
                    jsFileUploadId = data.fileUploadId;
                    ivRequestTypeCd = data.requestTypeCd;
                    jsPortalFileId = data.portalFileId;
                    ivUid = data.uid;

                    $(".iv-loading").removeClass("d-flex");
                    $(".iv-loading").addClass("d-none");
                    $("#image-viewer li").remove();
                    $(".iv-doc-container iframe").attr("src", "");

                    if (data.mimeType == "application/pdf") {

                        $(".iv-doc-container").removeClass("d-none");
                        //$(".iv-doc-container iframe").attr("src", data.result);

                        var queryString = '?fileUploadId=' + data.portalFileId + '&uid=' + data.uid + '&requestTypeCd=' + data.requestTypeCd;
                        $(".iv-doc-container iframe").attr("src", window.location.origin + app.baseHrefPart + '/en/FileUpload/ViewUploadedFile/' + queryString);


                        //$("#btn-iv-openfile").removeClass("d-none");
                    } else {
                        $("#btn-iv-zoomout").removeClass("d-none");
                        $("#btn-iv-zoomin").removeClass("d-none");
                        $("#btn-iv-rotleft").removeClass("d-none");
                        $("#btn-iv-rotright").removeClass("d-none");

                        $(".iv-img-container").removeClass("d-none");
                        $("#image-viewer").attr("src", data.result);

                        ivDocRotation = 0;
                        if (data.imageRotation) {
                            ivDocRotation = data.imageRotation;

                            // Make sure the image rotates in the right direction
                            if (ivDocRotation > 180) {
                                ivDocRotation = ivDocRotation - 360;
                            }
                        }

                        img.viewer({
                            navbar: false,
                            toolbar: false,
                            title: false,
                            fullscreen: false,
                            button: false,
                            tooltip: false,
                            inline: true,
                            zoomRatio: .5,
                            viewed: function () {
                                img.viewer('rotateTo', ivDocRotation);
                                //window.setSize(); //gives error
                            }
                        });

                        img.viewer("update");
                    }

                    //ivLoadCallback(data);
                }
                else {
                    //hide modal
                    $('#viewUploadedDocModal').modal('hide');
                }
            },
            error: function () {
                location.reload(true); // TODO: show an error message
            },
            fail: function (err) {
                console.log(err);
                $('#viewUploadedDocModal').modal('hide');
            }
        });
    }

    $(".open-file").on("click", function () {

        var url = '';
        var fileId = filedata.portalFileId;

        if (location.href.indexOf('/en/') > 0) {
            url = location.href.split('/en/')[0] + '/en/programs/cfafile/getfile/' + fileId;
        } else {
            url = location.href.split('/fr/')[0] + '/fr/programs/cfafile/getfile/' + fileId;
        }

        window.open(url, "_blank");
        return false;
    });

    function RotateOnView() {

    }

    function loadViewer(requesttypecd, portalfileId, uid) {

        if (requesttypecd && portalfileId) {
            var url = '';
            var queryString = '?fileUploadId=' + portalfileId + '&requestTypeCd=' + requesttypecd + '&uid=' + uid;
            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/FileUpload/GetFileData/' + queryString;
            } else {
                url = location.href.split('/fr/')[0] + '/fr/FileUpload/GetFileData/' + queryString;
            }
            SetImage(url);
            rescale();
        }
    }

    function rescale() {
        var size = { width: $(window).width(), height: $(window).height() }
        if (size.width < 500) {
            // do mobile
            /*CALCULATE SIZE*/
            var offset = 0;
            var offsetBody = 200;
            $('#viewUploadedDocModal').css('height', size.height + 10);
            $('.modal-body').css('height', 410);
            $('#viewUploadedDocModal').css('top', 0);
            $('.iv-img-container').css('height', '300px');
            $('.viewer-backdrop').css('height', '300px');

            $(".iv-doc-container").css("height", '330px');
        } else {
            // do desktop
            /*CALCULATE SIZE*/
            var offset = 20;
            var offsetBody = 155;

            $('.iv-img-container').css('height', '400px');
            $('.viewer-backdrop').css('height', '400px');

            $('#viewUploadedDocModal').css('height', size.height - offset);
            $('.modal-body').css('height', 550);
            $('#viewUploadedDocModal').css('top', 0);

            $(".iv-doc-container").css("height", size.height - (offset + offsetBody) - 90);
        }
    }
}